// Generated by CoffeeScript 2.7.0
var BatchJourneyOverlay;

import {
  newAssignmentSettingsModal
} from 'trunks/vue/admin/compositions/yet_another_workflow/assignment_settings_modal.js';

import BatchAssignmentsMixin from 'trunks/controllers/share/assignment.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default BatchJourneyOverlay = Vue.extend({
  mixins: [BatchAssignmentsMixin],
  template: `<div
  class="batch-assignment-overlay overlay assignment-overlay"
  :class="{ open: isOpen }"
  ref="overlay"
>
  <div class="content" ref="container">
    <div class="overlay-header">
      <div class="overlay-title">
        <span>批量处理</span>
      </div>
      <div class="closer" @click="close">
        <i class="slp-times"></i>
      </div>
    </div>
    <div class="batch-assignment-overlay-tip">
      <span class="error-text text-normal">您现在对流程进行批量处理，请谨慎操作！</span>
    </div>
    <div class="flow-wrapper">
      <div class="flow-fields-content">
        <div class="responses-content"></div>
        <div class="flow-footer justify-between">
          <div class="left">
            <div class="assignment-operations">
              <button
                v-if="canRemind"
                class="mr-4 link-btn btn-default"
                @click="remindEvent"
              >
                批量催促
              </button>
              <button
                class="mr-4 link-btn btn-danger"
                @click="cancelEvent"
              >
                批量撤销
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  props: {
    flowId: {
      type: String,
      required: true
    },
    journeys: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      isOpen: true
    };
  },
  computed: {
    updateUrl: function() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(`/yet_another_workflow/flows/${this.flowId}/journeys/proposer_batch_operation`);
    },
    canRemind: function() {
      return _.every(this.journeys, function(journey) {
        return journey.record.status !== 'receding';
      });
    }
  },
  methods: {
    open: function() {
      this.isOpen = true;
      return this._enableBackdrop();
    },
    close: function() {
      this.isOpen = false;
      Skylark.Helpers.App.removeCapturedBackdropByID(this._backdropId);
      this._backdropId = null;
      return this.confirm = null;
    },
    updateSetting: function(options) {
      return _.extend(this, options);
    },
    remindEvent: function() {
      return this._doRequest('remind');
    },
    cancelEvent: function() {
      return this._doRequest('cancel');
    },
    _doRequest: function(action) {
      var journey_ids;
      journey_ids = _.map(this.journeys, function(journey) {
        return journey.id;
      });
      return Skylark.Libs.Ajax.put(this.updateUrl, {
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: {
          ids: journey_ids,
          operation: action
        },
        success: (data, xhr) => {
          Skylark.Bridge.newAlertify(`批量${Skylark.Helpers.translate('assignment.operates.' + action)}成功`, {
            type: 'success'
          });
          return this.$emit('afterRequest');
        },
        error: function() {
          return Skylark.Bridge.newAlertify(`批量${Skylark.Helpers.translate('assignment.operates.' + action)}失败`, {
            type: 'error'
          });
        }
      });
    },
    _enableBackdrop: function() {
      var container;
      container = this.$refs.container;
      return this._backdropId = Skylark.Helpers.App.capturedBackdrop((event) => {
        return this.close();
      }, container);
    }
  }
});
